import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import type { UserProfile, SalesRoute } from '../types';

interface LayoutProps {
  user?: UserProfile | null;
  isAdmin?: boolean;
  currentRoute: SalesRoute;
  onNavigate: (route: SalesRoute) => void;
  onLogout: () => void;
  children: React.ReactNode;
  pendingPartnerApplications?: number;
}

const Layout: React.FC<LayoutProps> = ({
  user,
  isAdmin,
  currentRoute,
  onNavigate,
  onLogout,
  children,
  pendingPartnerApplications = 0,
}) => {
  return (
    <div className="min-h-screen flex flex-col bg-slate-900">
      <Header user={user} onLogout={onLogout} />
      <div className="flex flex-1 overflow-hidden">
        <Sidebar currentRoute={currentRoute} onNavigate={onNavigate} isAdmin={isAdmin} pendingPartnerApplications={pendingPartnerApplications} />
        <main className="flex-1 overflow-auto p-6 bg-slate-950">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
